import styled from "styled-components"
import axios from "axios"; //
import React, { useState, useEffect, useRef } from "react";
import { baseUrl } from "../config";
import { Table, ListContainer } from "./styles";
import { DateIRLToErache } from "../utils/dateConverters";
import { FaSortUp, FaSortDown } from "react-icons/fa";
import EventsList from "./EventsList";
import DetailDrawer from "./DetailDrawer";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Link } from "react-router-dom";

const MeEvents = () => {
    const [openDetail, setOpenDetail] = useState(null);
    const [events, setEvents] = useState([]);
    const [sortConfig, setSortConfig] = useState({
        key: "date",
        direction: "asc",
    });
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 20,
    });
    const [rowCount, setRowCount] = useState(0);
    const [columnFilters, setColumnFilters] = useState([]);

    // Prevent out-of-order responses overwriting a newer page.
    const fetchSeqRef = useRef(0);
    const fetchMyEvents = async (
        pageIndex = 0,
        pageSize = 20,
        sortKey = "date",
        sortDirection = "asc",
        columnFilters = []
    ) => {
        const fetchSeq = ++fetchSeqRef.current;
        try {
            const params = {
                page: pageIndex + 1,
                pageSize,
                sortKey,
                sortDirection,
            };
            columnFilters.forEach(filter => {
                params[filter.id] = filter.value;
            });
            params.authorPseudo = "me";
            const response = await axios.get(baseUrl + "/events", {
                withCredentials: true,
                params,
            });
            // Ignore stale responses.
            if (fetchSeq !== fetchSeqRef.current) return;
            setEvents(response.data.data);
            setRowCount(response.data.total);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        fetchMyEvents(
            pagination.pageIndex,
            pagination.pageSize,
            sortConfig.key,
            sortConfig.direction,
            columnFilters
        );
    }, [
        pagination.pageIndex,
        pagination.pageSize,
        sortConfig.key,
        sortConfig.direction,
        columnFilters,
    ]);

    const requestSort = (key) => {
        let direction = "asc";
        if (sortConfig.key === key && sortConfig.direction === "asc") {
            direction = "desc";
        }
        setSortConfig({ key, direction });
    };
    const refetchEvents = () => {
        fetchMyEvents(pagination.pageIndex, pagination.pageSize, sortConfig.key, sortConfig.direction, columnFilters);
    };

    return (
        <MeContainer>
            <h1>Liste des évènements que vous avez créés</h1>
            <Button
                variant="contained"
                startIcon={<AddIcon />}
                component={Link}
                to="/add-event"
                sx={{ alignSelf: "flex-start", mb: 2 }}
            >
                Créer un évènement
            </Button>
            <EventsList
                fetchEvents={fetchMyEvents}
                events={events}
                pagination={pagination}
                setPagination={setPagination}
                rowCount={rowCount}
                columnFilters={columnFilters}
                setColumnFilters={setColumnFilters}
                requestSort={requestSort}
                sortConfig={sortConfig}
                setSortConfig={setSortConfig}
                DateIRLToErache={DateIRLToErache}
                FaSortUp={FaSortUp}
                FaSortDown={FaSortDown}
                ListContainer={ListContainer}
                Table={Table}
                onOpenEventDetail={(id) => setOpenDetail({ type: "event", id })}
            />
            <DetailDrawer
                open={openDetail}
                onClose={() => setOpenDetail(null)}
                onOpenDetail={setOpenDetail}
                onEventDeleted={refetchEvents}
                DateIRLToErache={DateIRLToErache}
            />
        </MeContainer>
    );
};


export default MeEvents;


const MeContainer = styled(ListContainer)`
  max-width: 100vw;
  width: 100%;
  margin: 0 auto;
  padding: 0 10px; // Avoid content to touch sides
`;